import { render, staticRenderFns } from "./TaskAperte.vue?vue&type=template&id=8eb9c7e8&"
import script from "./TaskAperte.vue?vue&type=script&lang=js&"
export * from "./TaskAperte.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports